import Link from 'next/link';
import Image from 'next/legacy/image';
import { format } from 'date-fns';

import { H4 } from '@common/headline';
import { BodyRegular, BodySmall } from '@common/body';

type Props = {
  imageUrl: string;
  category: string;
  columnsPerRowDesktop: 2 | 3;
  date?: Date;
  description?: string;
  href: string;
  shouldDisplayCategory: boolean;
  title: string;
};

const ArticleTile = ({
  imageUrl,
  category,
  columnsPerRowDesktop,
  date,
  description,
  href,
  shouldDisplayCategory,
  title,
}: Props): JSX.Element => {
  const mediumWidthClass = {
    2: 'md:w-[calc(50%-20px)]',
    3: 'md:w-[calc(33.3333%-20px)]',
  };

  return (
    <Link
      href={href}
      className={`w-full transition duration-100 ease-in-out hover:translate-y-[-2%] ${mediumWidthClass[columnsPerRowDesktop]} mt-3 text-blue md:mx-2 md:my-5`}
    >
      <Image
        src={imageUrl}
        width={360}
        height={203}
        layout="responsive"
        alt={title}
      />
      {shouldDisplayCategory && (
        <div className="mb-1 mt-4 uppercase">
          <BodySmall>{category}</BodySmall>
        </div>
      )}
      <div className={shouldDisplayCategory ? 'mt-0' : 'mt-2'}>
        <H4>{title}</H4>
      </div>
      {description && (
        <div className="mb-10">
          <BodyRegular>{description}</BodyRegular>
        </div>
      )}
      {date && (
        <div className="mb-10 mt-[-10px]">
          <BodyRegular>{format(new Date(date), 'do MMMM yyyy')}</BodyRegular>
        </div>
      )}
    </Link>
  );
};

ArticleTile.defaultProps = {
  columnsPerRowDesktop: 3,
  shouldDisplayCategory: true,
};

export default ArticleTile;
